export enum JobWorkSummaryDataType {
	ORIGINAL = 'ORIGINAL', // Represents state of Work Summary Details in FR
	UPDATED = 'UPDATED', // Update on the original
	STANDALONE = 'STANDALONE' // Created from Job Work Summary table, not connected to FR WSDs
}
